var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapMeasurestop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0788 376.208L114.573 312.714C108.218 316.009 100.207 314.99 94.8751 309.659L63.0554 277.839C62.4474 277.232 61.8957 276.588 61.4001 275.918C37.1334 300.391 25 314.402 25 331.353C25 345.704 33.6929 357.945 51.0788 376.208ZM121.795 305.491L153.981 273.305L110.785 230.11C110.173 229.498 109.617 228.85 109.119 228.173L84.9839 252.309C85.6602 252.806 86.308 253.362 86.9202 253.974L118.74 285.793C124.071 291.125 125.09 299.136 121.795 305.491ZM249.706 321.831L123.19 448.346C141.788 466.115 154.139 475 168.646 475C187.708 475 203.048 459.661 233.727 428.982L233.727 428.981L233.73 428.978L295.292 367.417L249.706 321.831ZM321.831 249.706L448.346 123.19C466.115 141.788 475 154.139 475 168.646C475 187.708 459.661 203.048 428.982 233.727L428.981 233.727L428.978 233.73L367.417 295.292L321.831 249.706ZM376.208 51.0787C357.945 33.6929 345.704 25 331.353 25C314.402 25 300.391 37.1334 275.918 61.4001C276.588 61.8957 277.232 62.4474 277.839 63.0554L309.659 94.8751C314.99 100.207 316.009 108.218 312.714 114.573L376.208 51.0787ZM305.491 121.795L273.305 153.981L230.11 110.785C229.498 110.173 228.85 109.617 228.173 109.119L252.309 84.9839C252.806 85.6602 253.362 86.308 253.974 86.9202L285.793 118.74C291.125 124.071 299.136 125.09 305.491 121.795Z",
    fill: "#333333",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 80L419.411 419.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.411 80L80 419.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapMeasurestop);
export default __webpack_public_path__ + "static/media/ico_map_measurestop.99513dde6b434e3f685beda89aa479bf.svg";
export { ForwardRef as ReactComponent };